import FormattedMessage from 'I18n/components/FormattedMessage';
import { ChatWidgetLocaleContextConsumer } from 'conversations-visitor-experience-components/visitor-widget/ChatWidgetLocaleContext';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { getHideNewThreadLink } from '../../query-params/getHideNewThreadLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NewThreadpromptContainer = styled.div.withConfig({
  displayName: "NewThreadPrompt__NewThreadpromptContainer",
  componentId: "sc-9cplrv-0"
})(["padding:32px 20px 12px 20px;text-align:center;width:100%;"]);
function NewThreadPrompt({
  createNewThread,
  isChatTransferred
}) {
  const hideNewThreadLink = getHideNewThreadLink();
  return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
    children: locale => /*#__PURE__*/_jsxs(NewThreadpromptContainer, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: isChatTransferred ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-experience-components.newThreadPrompt.chatMovedToEmail",
          options: {
            locale
          }
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newHeading",
          options: {
            locale
          }
        })
      }), !hideNewThreadLink && /*#__PURE__*/_jsx(VizExLink, {
        "data-test-id": "visitor-widget-start-new-thread-button",
        onPress: createNewThread,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-visitor-ui.newThreadPrompt.newButton",
          options: {
            locale
          }
        })
      })]
    })
  });
}
NewThreadPrompt.propTypes = {
  createNewThread: PropTypes.func.isRequired,
  isChatTransferred: PropTypes.bool.isRequired
};
NewThreadPrompt.displayName = 'NewThreadPrompt';
export default NewThreadPrompt;